import {
  IGetResReadReceiptDetail,
  IGetResReadReceiptSummary,
  ReadReceiptSubjectType,
} from '../../frontend-libs/evlapp-types';

import RestApi from './RestApi/RestApi';
import { store } from '../store/store';

export const getReadReceiptDetail = async (
  subjectType: ReadReceiptSubjectType,
  subjectId: string
): Promise<IGetResReadReceiptDetail> => {
  const buildingId = store.getState().security.ui.buildingId;

  return await RestApi.get<never, IGetResReadReceiptDetail>(
    `/building/${buildingId}/read-receipt/${subjectType}/${subjectId}`
  );
};

export const getReadReceiptSummary = async (
  subjectType: ReadReceiptSubjectType
): Promise<IGetResReadReceiptSummary> => {
  const buildingId = store.getState().security.ui.buildingId;

  return await RestApi.get<never, IGetResReadReceiptSummary>(`/building/${buildingId}/read-receipt/${subjectType}`);
};
